<template>
  <div class="container">
    <van-image width="100%" :src="activityDetail.coverImage" />
    <section class="page-title">
      <van-image :src="require('@/assets/culturalRelic/baoming@2x.png')" />
      <p>{{ activityDetail.title }}</p>
    </section>
    <section class="page-body">
      <van-image class="pattern" :src="require('@/assets/culturalRelic/wen@2x.png')" />
      <section class="detail">
        <div class="content" v-html="activityDetail.introduce"></div>
      </section>
      <section class="section">
        <h4>活动时间：</h4>
        <div>{{ activityDetail.activityTime }}</div>
      </section>
      <section class="section">
        <h4>活动对象：</h4>
        <div>{{ activityDetail.allowAgeStr }}</div>
      </section>
      <section class="section">
        <h4>参与人数：</h4>
        <div>{{ activityDetail.participantsNum }}</div>
      </section>
      <section class="section">
        <h4>签到地点：</h4>
        <!-- <div>{{ activityDetail.gatherSignLocation }}</div> -->
        <div>{{ activityDetail.signLocation }}</div>
      </section>
      <section class="section">
        <h4>咨询电话：</h4>
        <div>{{ activityDetail.consultationPhone }}</div>
      </section>
      <section class="section" v-if="activityDetail.useQrcode !== 0">
        <h4>报名方式：</h4>
        <div>长按识别下方二维码</div>
        <img class="qrCode" :src="activityDetail.qrcode" alt="">
      </section>
      <div class="tip topTip">
        *注意： 如果三次报名未到场参加，您将无法报名本年度其他活动！
      </div>
    </section>
    <section class="signup-form" v-if="activityDetail.useQrcode == 0">
      <van-image class="pattern" :src="require('@/assets/baoming.png')" />
       <!-- <p class="Tips">集合签到地点：主馆外东北角楼，教育空间</p> -->
       <p class="Tips">集合签到地点：{{activityDetail.gatherSignLocation}}</p>
      <van-form class="form" label-align="right" label-width="90" @submit="onSubmit" colon scroll-to-error>
        <div>
          <van-field name="radio" label="活动场次" required v-if="activityDetail.sessionList.length !== 0">
            <template #input>
              <van-radio-group v-model="form.radio">
                <van-radio :disabled="item.remainNum == 0" :name="item.id" v-for="item of activityDetail.sessionList" :key="item.id">
<!--                  <span class="colors">{{ item.startTime +' ~ '+ item.endTime }}</span>-->
                  <span class="colors">{{ item.title }}</span>
                  <span class="colors" v-if="item.remainNum == 0" style="display: block">(本场活动名额已满，感谢您的关注!)</span>
                </van-radio>
              </van-radio-group>
              <!-- eslint-disable no-irregular-whitespace-->
            </template>
          </van-field>
          <van-field
            v-else
            v-model="form.over"
            name="username"
            label="活动场次"
            required
            disabled
            placeholder="暂无活动场次"
          />
          <div class="tip">*注意：活动开始前五分钟停止签到!</div>
          <van-field
            type="tel"
            v-model="form.phoneNumber"
            name="phoneNumber"
            label="联系方式"
            required
            placeholder="请输入您的联系方式"
            :rules="[{ required: true, message: '请正确填写联系方式', pattern: /^(13[0-9]|14[5|7]|15[0|1|2|3|4|5|6|7|8|9]|18[0|1|2|3|4|5|6|7|8|9])\d{8}$/ }]"
          />
          <div class="tip">*注意：活动现场需要使用本号码签到</div>
          <van-field name="stepper" label="选择数量" required>
            <template #input>
              <van-stepper @minus="onChangeStepper('down')" @plus="onChangeStepper('up')" v-model="form.stepper" />
            </template>
          </van-field>
        </div>
        <div>
          <template v-for="(item, index) of form.group">
            <div class="item" :key="index">
<!--              class="nameyz"-->
              <!-- eslint-disable no-irregular-whitespace-->
              <van-field
                v-model="form.group[index].name"
                name="username"
                label="姓　　名"
                required
                placeholder="请输入您的姓名"
                :rules="[{ required: true, message: '请填写姓名' }]"
              />
              <van-field
                v-model="form.group[index].idNumber"
                name="idNumber"
                label="身份证号"
                required
                @blur="computedAge(form.group[index].idNumber, index)"
                placeholder="请输入您的身份证号"
                :rules="[{ required: true, message: '请正确填写身份证号', pattern: /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/ }]"
              />
              <van-field
                v-model="form.group[index].age"
                name="age"
                type="digit"
                label="年　　龄"
                required
                readonly
                placeholder="请输入您年龄"
                :rules="[{ required: true, message: '请正确填写年龄' }]"
              />
            </div>
          </template>
        </div>
        <div>
          <h5>温馨提示：</h5>
          <div class="content">
            {{ activityDetail.registrationRead }}
          </div>
        </div>
        <van-button native-type="submit" style="width: 80%" round block text="提交" color="#773E36" />
      </van-form>
    </section>
    <van-button v-if="activityDetail.useQrcode == 0" native-type="button" style="width: 80%" round block text="我的报名" color="#773E36" :to="{ path: `/educational/queryResule?consultationPhone=${activityDetail.consultationPhone}`, query: { id: $route.query.id } }" />
  </div>
</template>

<script>
import { getActivityDetail, submitApply } from '@/api/educational'
export default {
  name: 'EducationalSignup',
  data: () => ({
    activityDetail: {},
    detail: '<p>hello world</p>',
    form: {
      group: [{
        name: null,
        idNumber: null,
        age: null
      }]
    }
  }),
  created () {
    const id = this.$route.query.id
    id && this.getActivityDetail(id)
  },
  methods: {
    async getActivityDetail (id) {
      const { result } = await getActivityDetail(id)
      console.log(result)
      this.activityDetail = result
    },
    onChangeStepper (direction) {
      if (direction === 'down') {
        this.form.group.pop()
      } else {
        this.form.group.push({
          name: '',
          idNumber: null,
          age: null
        })
      }
    },
    async onSubmit (event) {
      if (this.activityDetail.sessionList.length === 0) {
        this.$toast.fail('活动已截止')
        return
      }
      console.log(event)
      try {
        const { result } = await submitApply({
          eduId: this.$route.query.id,
          sessionId: event.radio,
          num: event.stepper,
          phone: event.phoneNumber,
          detailList: this.form.group
        })
        console.log(result)
        this.$toast.success('报名成功')
        this.$router.push('/educational/signResult?id=' + this.$route.query.id)
      } catch (err) {
        this.$toast.fail(err)
      }
    },
    computedAge (idCard, index) {
      console.log(idCard, index)
      this.form.group[index].age = this.getAgeFormIdCard(idCard)
    },
    getAgeFormIdCard (idCard) {
      const length = idCard.length
      const date = new Date()
      const month = date.getMonth() + 1
      const day = date.getDate()
      let age = 0
      if (length === 18) {
        age = date.getFullYear() - idCard.substring(6, 10) - 1
        if (idCard.substring(10, 12) < month || (idCard.substring(10, 12) === month && +idCard.substring(12, 14) <= day)) age++
      }
      if (length === 15) {
        age = date.getFullYear() - idCard.substring(6, 8) - 1901
        if (idCard.substring(8, 10) < month || (idCard.substring(8, 10) === month && +idCard.substring(10, 12) <= day)) age++
      }
      return age
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .van-cell__title {
  padding-right: 15px;
}
::v-deep .van-cell--required::before {
  top: 10px;
  left: 10px;
}
::v-deep .van-stepper {
  .van-stepper__input {
    background-color: transparent !important;
  }
}
.colors {
  color:#906F5D;
  vertical-align: middle;
}
.content {
  font-size: 13px;
  line-height: 1.8;
  ::v-deep img {
    width: 100%;
    height: auto;
  }
}
.container {
  font-family: 'PingFangMedium';
  min-height: 100vh;
  background-color: #F7EEE8;
  overflow: hidden;
  .Tips {
    font-size: 14px;
    font-weight: 400;
    color:#835F4B;
  }
  .qrCode {
    width: 150px;
    display: block;
    margin: 0 auto;
    margin-top: 20px;
  }
  ::-webkit-input-placeholder { color:#BAA69C; }
  .page-title {
    margin: 0 12px;
    background: #F3E6DD;
    box-shadow: 0 0 10px 0 rgba(110, 99, 93, .3);
    border-radius: 6px;
    padding: 20px 12px;
    box-sizing: border-box;
    position: relative;
    top: -14px;
    z-index: 2;
    .van-image {
      width: 108px;
    }
    p {
      text-align: center;
      font-size: 14px;
      line-height: 1.4;
    }
  }
  .page-body {
    margin: 0 12px;
    margin-bottom: 20px;
    background: #F3E6DD;
    box-shadow: 0px 0px 10px 0px rgba(110, 99, 93, 0.3);
    border-radius: 7px;
    padding: 16px 14px;
    box-sizing: border-box;
    color: #312925;
    line-height: 1.7;
    position: relative;
    .section {
      font-size: 14px;
    }
    .topTip {
      width: 100%;
      text-align: left;
    }
    .tip {
      margin-top: 20px;
      color: #773f36;
      font-size: 13px;
      line-height: 1.5;
    }
    h4 {
      margin: 0;
      margin-top: 20px;
      display: inline-block;
      font-size: 14px;
    }
    .pattern {
      width: 242px;
      position: absolute;
      right: -12px;
      top: -25px;
      z-index: 2;
    }
    .detail {
      .content {
        ::v-deep img {
          max-width: 100%;
          height: auto;
        }
      }
    }
  }
  .signup-form {
    .form {
      ::v-deep .nameyz {
        &::before {
          left: 36px;
        }
      }
      > div {
        &:first-child {
          padding: 0 25px;
        }
        .van-radio-group {
          width: 100%;
          //box-shadow: inset 0 0 4px 0 rgba(110, 99, 93, .3);
          //border: 1px solid #ccc;
          background-color: #F1E6DD;
          border-radius: 3px;
        }
        .van-radio {
          align-items: flex-start;
          padding: 12px 10px;
        }
        ::v-deep .van-radio__icon .van-icon {
          font-size: 0.6em;
        }
        .tip {
          font-size: 12px;
          color: #773F36;
          line-height: 2;
          margin-left: 102px;
        }
        ::v-deep .van-stepper__minus--disabled,
        ::v-deep .van-stepper__plus,
        ::v-deep .van-stepper__minus{
          background-color: #F7EEE8;
          &:active {
            background-color: #F1E6DD;
          }
        }
        ::v-deep .van-stepper {
          .van-field__body {
            input {
              background-color: transparent !important;
            }
          }
          > button, input {
            //background-color: transparent;
            //border: none;
            //box-shadow: none;
          }
          > button {
            color: #773f36;
          }
        }
        ::v-deep .van-field__control {
          justify-content: flex-end;
        }
        &:nth-child(2) {
          padding: 0 25px;
          ::v-deep .item {
            padding: 13px 0;
            //border: 1px solid #ccc;
            //box-shadow: inset 0 0 4px 0 rgba(110, 99, 93, .3);
            background-color: #F1E6DD;
            margin-bottom: 10px;
            .van-field__body {
              input, textarea {
                //border: 1px solid #aaa;
                //box-shadow: inset 0 0 3px #ccc;
                background-color: #F7EEE8;
                border-radius: 3px;
                padding: 0 6px;
              }
              input {
                height: 35px;
              }
              textarea {
                height: 100px;
              }
            }
          }
        }
        &:nth-last-child(2) {
          margin: 0 24px 0 24px;
          color: #312925;
          background-color: #F1E6DD;
          padding: 20px 10px;
          box-sizing: border-box;
          text-align: justify;
          h5 {
            font-size: 16px;
            font-weight: 400;
            line-height: 1.8;
            margin: 15px 0;
            margin-top: 0;
            text-align: center;
          }
          .content {
            font-size: 14px;
            line-height: 1.8;
            color: #666666;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    .pattern {
      width: 108px;
      margin-left: 29px;
    }
    p {
      margin-left: 35px;
    }
    ::v-deep .van-cell {
      background-color: transparent;
      .van-field__label {
        width: 5em;
        margin-right: 0;
        padding-top: 6px;
      }
      &.van-field {
        padding: 5px 15px;
      }
      .van-field__word-limit {
        margin-top: -18px;
        margin-right: 8px;
      }
      .van-field__body {
        input, textarea {
          //border: 1px solid #aaa;
          //box-shadow: inset 0 0 3px #ccc;
          background-color: #F1E6DD;
          border-radius: 3px;
          padding: 0 6px;
        }
        input {
          height: 35px;
        }
        textarea {
          height: 100px;
        }
      }
    }
  }
  ::v-deep .van-button {
    font-size: 16px;
    display: block;
    height: 33px;
    margin: 26px auto;
    padding: 8px 30px;
    .van-button__text {
      color: #eee;
    }
  }
}
</style>
